// extracted by mini-css-extract-plugin
export default {"flowsheetCareComponentsContainer":"FlowsheetContent_flowsheetCareComponentsContainer__I0IYq","careComponentContainer":"FlowsheetContent_careComponentContainer__2ER0a"};